import React from "react";
import GlobalDialog from "../mui/Dialogue/GlobalDialog";
import {
    AddButton,
    CancelButton,
    EditButton,
    SaveButton,
} from "../mui/Buttons/Buttons";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
    getMiscMaster,
    editMiscMaster,
} from "../../redux/features/mastersSlice";
import { useSnackbar } from "notistack";

export const EditMiscMaster = ({ params }) => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);

    const data = useSelector((state) => state.masters);

    const Schema = Yup.object().shape({
        masterName: Yup.string().required("masterName is required"),
        masterType: Yup.string().required("masterType is required"),
        masterDescription: Yup.string().required(
            "masterDescription is required"
        ),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            miscMasterId: params.miscMasterId,
            masterName: params.masterName || "",
            masterType: params.masterType || "",
            masterDescription: params.masterDescription || "",
        },
        validationSchema: Schema,
        onSubmit: (values, { resetForm }) => {
            dispatch(editMiscMaster(values)).then((res) => {
                if (res.payload.status === "failed") {
                    enqueueSnackbar(res.payload.message, { variant: "error" });
                } else if (res.payload.status === "success") {
                    setOpen(false);
                    resetForm();
                    dispatch(getMiscMaster());
                    enqueueSnackbar(res.payload.message, {
                        variant: "success",
                    });
                }
            });
        },
    });
    return (
        <div>
            <GlobalDialog
                title="Add MiscMaster"
                open={open}
                setOpen={setOpen}
                fullWidth
                maxWidth={"sm"}
                popupButton={
                    <Box sx={{ padding: 1 }}>
                        <EditButton
                            size="small"
                            action={() => {
                                setOpen(true);
                            }}
                        >
                            Edit
                        </EditButton>
                    </Box>
                }
                content={
                    <>
                        <FormikProvider value={formik}>
                            <Form onSubmit={formik.handleSubmit}>
                                <Box>
                                    <Stack direction={"column"} spacing={2}>
                                        <TextField
                                            label="Master Name"
                                            fullWidth
                                            name="masterName"
                                            value={formik.values.masterName}
                                            onChange={formik.handleChange}
                                            error={
                                                formik.touched.masterName &&
                                                Boolean(
                                                    formik.errors.masterName
                                                )
                                            }
                                            helperText={
                                                formik.errors.masterName
                                            }
                                        />

                                        <TextField
                                            label="Master Type"
                                            fullWidth
                                            name="masterType"
                                            value={formik.values.masterType}
                                            onChange={formik.handleChange}
                                            error={
                                                formik.touched.masterType &&
                                                Boolean(
                                                    formik.errors.masterType
                                                )
                                            }
                                            helperText={
                                                formik.errors.masterType
                                            }
                                        />

                                        <TextField
                                            label="Master Description"
                                            fullWidth
                                            name="masterDescription"
                                            multiline
                                            rows={3}
                                            value={
                                                formik.values.masterDescription
                                            }
                                            onChange={formik.handleChange}
                                            error={
                                                formik.touched
                                                    .masterDescription &&
                                                Boolean(
                                                    formik.errors
                                                        .masterDescription
                                                )
                                            }
                                            helperText={
                                                formik.errors.masterDescription
                                            }
                                        />
                                    </Stack>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            marginTop: 2,
                                        }}
                                    >
                                        <Stack spacing={2} direction={"row"}>
                                            <CancelButton
                                                action={() => setOpen(false)}
                                            >
                                                Cancel
                                            </CancelButton>
                                            <SaveButton type="submit">
                                                {data.loading
                                                    ? "Saving..."
                                                    : "Save"}
                                            </SaveButton>
                                        </Stack>
                                    </Box>
                                </Box>
                            </Form>
                        </FormikProvider>
                    </>
                }
            />
        </div>
    );
};
